import axios from 'axios';
import store from '@/store';

export async function receiptRequest(path, data = {}) {
  const res = await axios.post(process.env.VUE_APP_API_BASE_URL + path, data, {
    headers: { 'Content-Type': 'application/json', Authorization: store.getters.authCode || '' }, timeout: 30000
  });
  if (res.data.code !== 200) throw new Error(res.data.msg || res.data.message || '操作失败');
  return res.data.data;
}
export function readReceiptImage(file) {
  return new Promise((resolve, reject) => {
    if (!['image/png', 'image/jpeg'].includes(file.type) || file.size > 1024 * 1024) {
      reject(new Error('请选择1MB以内的PNG、JPG收款码')); return;
    }
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = () => reject(new Error('图片读取失败'));
    reader.readAsDataURL(file);
  });
}
